export default __webpack_public_path__ + "static/media/flicked-arrow.9d31b3a0.png";